import { FC, useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { AxiosProgressEvent } from "axios"

import { UFileProcessingCard } from "../../../components"
import { useAppDispatch } from "../../../core/app/hooks"
import { uploadXray } from "../../../core/app/slices/records/xrays/xraysThunkApi"

const UploadXrayProcessing: FC<{
  file: File
  onRemove: (f: any) => void
  onUploadSuccess?: (val: File[]) => void
  radioGraphType: string
  isRefinement?: boolean
}> = ({ file, onRemove, onUploadSuccess, radioGraphType, isRefinement }) => {
  const [progressValue, setProgressValue] = useState<number>(0)
  const [progressStatus, setProgressStatus] = useState<
    "loading" | "complete" | "failed"
  >("loading")

  const dispatch = useAppDispatch()
  const { patientId, caseId } = useParams()

  useEffect(() => {
    const newFile = new File(
      [file],
      `${radioGraphType}.${file.type.split("/")[1]}`,
      {
        type: file.type,
      },
    )
    const formPayload = new FormData()
    formPayload.append("attachment", newFile)
    formPayload.append("original_file_name", file.name)
    if (isRefinement) formPayload.append("is_refinement", "1")
    dispatch(
      uploadXray({
        file,
        radioGraphType,
        patientId: patientId,
        caseId: caseId,
        formData: formPayload,
        fileName: newFile.name,
        orgId: "",
        onFileProcesscallback: function (progress: AxiosProgressEvent): void {
          const { loaded, total } = progress
          setProgressStatus("loading")
          const percentageProgress = Math.floor((loaded / total) * 100)
          setProgressValue(percentageProgress)
        },
      }),
    ).then((action) => {
      if (action.payload.status === 200) {
        setProgressStatus("complete")
        onUploadSuccess && onUploadSuccess([])
      } else {
        setProgressStatus("failed")
      }
    })
  }, [file])

  return (
    <UFileProcessingCard
      fileName={file.name}
      fileSize={file.size}
      progressValue={progressValue}
      progressstatus={progressStatus}
      onRemove={() => onRemove(file)}
    />
  )
}

export default UploadXrayProcessing
